import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React, { useCallback } from "react";

import { Button as DefaultButton, Flex, Icon, Text } from "~/components/blocks";
import { isAccessingFromDesktop } from "~/utils/user_agent";

export const ACCEPT_TYPES = ["image/png", "image/jpg", "image/jpeg"];

type Props = {
  onChange: (files: FileList) => void;
};

const Input = styled("input")(() =>
  css({
    display: "none",
  }),
);

const MenuIcon = styled(Icon)(() =>
  css({
    width: "32px",
    height: "32px",
  }),
);

const Button = styled(DefaultButton)(() =>
  css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  }),
);

export const UploaderButtons = React.memo((props: Props) => {
  const { onChange } = props;
  const theme = useTheme();

  const isDesktop = isAccessingFromDesktop();
  const accept = ACCEPT_TYPES.join(",");

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.currentTarget.files;
      if (files) {
        onChange(files);
      }
    },
    [onChange],
  );

  return isDesktop ? (
    <Button wide="fill" size="xxl" as="label">
      <Input type="file" multiple accept={accept} onChange={handleChange} />
      <MenuIcon icon="photo" />
      <Text block size="m">
        画像を選択する
      </Text>
    </Button>
  ) : (
    <Flex justifyContent="space-between">
      <Button wide="fill" size="xxl" as="label">
        <Input
          type="file"
          multiple
          accept={accept}
          capture="environment" // 外向きカメラ
          onChange={handleChange}
        />
        <MenuIcon icon="camera" />
        <Text block size="m">
          撮影する
        </Text>
      </Button>
      <Button wide="fill" size="xxl" marginLeft={theme.space.m} as="label">
        <Input type="file" multiple accept={accept} onChange={handleChange} />
        <MenuIcon icon="photo" />
        <Text block size="m">
          画像を選択する
        </Text>
      </Button>
    </Flex>
  );
});

UploaderButtons.displayName = "UploaderButtons";
